import { createAction, props } from '@ngrx/store';
import { ILookupFields } from '../entities/lookup-fields.entity';

export const updateLookupData = createAction(
  '[Lookups API] Update Lookup Data',
  props<{ lookupData: ILookupFields }>()
);
